import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe, getLocaleDateTimeFormat } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../global.service';
import { PaymentConfirmationObj, BookAppointment, HospitalDetails, ReferralSourceDtls, CommunicationDetails } from '../Class/BookAppointment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FilterPipe } from 'ngx-filter-pipe';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
//declare var jQuery: any;
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})



export class PaymentComponent implements OnInit {

  public PaymentConfirmationObj: PaymentConfirmationObj;
  httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
  options = {
    headers: this.httpHeaders
  };

  public payuform: any = {};
  disablePaymentButton: boolean = true;
  getShortName(fullName) {
    var abc = fullName.split(' ').map(n => n[0]).join('');
    return abc.substring(0, 2);
  }

  selectedBooAppointmentData;
  PaymentgatewayUrl;
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private router: Router, private globalService: GlobalService, private activeRoute: ActivatedRoute, private ngxLoader: NgxUiLoaderService, private myElement: ElementRef, private datePipe: DatePipe) {

  }



  ngOnInit() {
    this.baseUrl = environment.baseUrl;
    this.selectedBooAppointmentData = this.globalService.getbookAppointmentData();
    const queryParams = this.activeRoute.snapshot.queryParams;

    console.log(JSON.stringify(this.selectedBooAppointmentData));

    const routeParams = this.activeRoute.snapshot.params;


    // this.createFormControls();
    //this.createForm();
    //  this.ngxLoader.start();
    this.PaymentConfirmationObj = new PaymentConfirmationObj();

    this.PaymentConfirmationObj.firstname = this.selectedBooAppointmentData.FirstName;
    this.PaymentConfirmationObj.email = this.selectedBooAppointmentData.PatientEmail;
    this.PaymentConfirmationObj.phone = this.selectedBooAppointmentData.PatientMobile;
    this.PaymentConfirmationObj.amount = this.selectedBooAppointmentData.totalAmount;
    this.PaymentConfirmationObj.appointmentdate = this.selectedBooAppointmentData.ConsultationDt;
    var currentDate = new Date();
    this.PaymentConfirmationObj.appointmenttime = this.selectedBooAppointmentData.StartTime;
    this.PaymentConfirmationObj.slotTime = this.selectedBooAppointmentData.avgconsultationTime;
    this.PaymentConfirmationObj.doctorname = this.selectedBooAppointmentData.CommunicationDetails.DoctorName;
    this.PaymentConfirmationObj.doctormobile = this.selectedBooAppointmentData.CommunicationDetails.DoctorMobile;
    this.PaymentConfirmationObj.doctoremail = this.selectedBooAppointmentData.CommunicationDetails.DoctorEmail;
    this.PaymentConfirmationObj.CommunicationMobileNo = this.selectedBooAppointmentData.CommunicationDetails.CommunicationMobileNo;
    this.PaymentConfirmationObj.CommunicationEmailId = this.selectedBooAppointmentData.CommunicationDetails.CommunicationEmailId;
    this.PaymentConfirmationObj.key = "xxz1z6X2";
    this.PaymentConfirmationObj.productinfo = this.selectedBooAppointmentData.ProductType;
    this.PaymentConfirmationObj.service_provider = "payu_paisa";


    var surl = "";
    surl = this.baseUrl + "/Home/PaymentResultSuccess";
    console.log(surl);

    var furl = "";
    furl = this.baseUrl + "/Home/PaymentResultFailure";

     
   
    this.PaymentConfirmationObj.surl = surl;
    this.PaymentConfirmationObj.furl = furl;
    this.PaymentConfirmationObj.hash = this.selectedBooAppointmentData.hash;
    this.PaymentConfirmationObj.txnid = this.selectedBooAppointmentData.txnid;
    this.PaymentConfirmationObj.udf1 = this.selectedBooAppointmentData.udf1;
    this.PaymentConfirmationObj.udf2 = this.selectedBooAppointmentData.udf2;
    this.PaymentConfirmationObj.udf3 = this.selectedBooAppointmentData.udf3;
    this.PaymentConfirmationObj.udf4 = this.selectedBooAppointmentData.udf4;
    this.PaymentConfirmationObj.udf5 = this.selectedBooAppointmentData.udf5;
    this.PaymentConfirmationObj.consultationFee = this.selectedBooAppointmentData.consultationFee;
    this.PaymentConfirmationObj.additionalCharges = this.selectedBooAppointmentData.additionalCharges;
    this.PaymentConfirmationObj.totalCost = this.selectedBooAppointmentData.totalAmount;
    this.PaymentConfirmationObj.zipcode = this.selectedBooAppointmentData.zipcode;
    this.PaymentConfirmationObj.city = this.selectedBooAppointmentData.city;
    this.PaymentConfirmationObj.IsTeleMedicineSlot = this.selectedBooAppointmentData.IsTeleMedicineSlot;
    this.PaymentConfirmationObj.parentHospitalId = this.selectedBooAppointmentData.city;
    console.log(this.selectedBooAppointmentData.RedirectUrl);
    this.PaymentConfirmationObj.address1 = this.selectedBooAppointmentData.RedirectUrl;
     
    //this.PaymentgatewayUrl = "https://secure.payu.in/_payment";//For Production
    this.PaymentgatewayUrl = "https://test.payu.in/_payment"; //For Testing
  }







  PayNow() {
    var params = {
      "TransactionId": 0,
      "TransactionKey": "",
      "MerchentKey": "",
      "SaltKey": "",
      "PatientId": 4967,
      "AppointmentId": 23525,
      "UserId": 3,
      "FirstName": this.PaymentConfirmationObj.firstname,
      "Email": this.PaymentConfirmationObj.email,
      "Mobile": this.PaymentConfirmationObj.phone,
      "ProductType": this.PaymentConfirmationObj.productinfo,
      "Amount": this.PaymentConfirmationObj.amount,
      "Hash": "",
      "udf1": this.PaymentConfirmationObj.udf1,
      "udf2": this.PaymentConfirmationObj.udf2,
      "udf3": this.PaymentConfirmationObj.udf3,
      "udf4": this.PaymentConfirmationObj.udf4,
      "udf5": this.PaymentConfirmationObj.udf5
    };
    this.ngxLoader.start();
    this.http.post<any>(this.baseUrl + "/api/MasterPatient/createTxnHashForAppointment", params, this.options).subscribe(result => {
      console.log(result);
      if (result.Status === 'Success') {
        this.PaymentConfirmationObj.hash = result.HashKey;
        this.PaymentConfirmationObj.txnid = result.TransactionKey;
        // this.boltsubmit();
      }
      this.ngxLoader.stop();





    }, error => console.error(error));

  }

  //boltsubmit() {
  //  var RequestData = {
  //    key: this.PaymentConfirmationObj.key,
  //    txnid: this.PaymentConfirmationObj.txnid,
  //    hash: this.PaymentConfirmationObj.hash,
  //    amount: this.PaymentConfirmationObj.amount,
  //    firstname: this.PaymentConfirmationObj.firstname,
  //    email: this.PaymentConfirmationObj.email,
  //    phone: this.PaymentConfirmationObj.phone,
  //    productinfo: this.PaymentConfirmationObj.productinfo,
  //    service_provider: 'payu_paisa',
  //    surl: 'http://localhost:8000/app/templates/appointment/PaymentResponse.html',
  //    furl: 'http://localhost:8000/app/templates/appointment/PaymentResponse.html',
  //    udf1: this.PaymentConfirmationObj.udf1,
  //    udf2: this.PaymentConfirmationObj.udf2,
  //    udf3: this.PaymentConfirmationObj.udf3,
  //    udf4: this.PaymentConfirmationObj.udf4,
  //    udf5: this.PaymentConfirmationObj.udf5
  //  }

  //  var Handler = {

  //    responseHandler: function (BOLT) {
  //      console.log(JSON.stringify(BOLT));
  //      // your payment response Code goes here, BOLT is the response object


  //      if (BOLT.response.txnStatus != 'CANCEL') {


  //      }

  //    },
  //    catchException: function (BOLT) {
  //      console.log(BOLT);

  //    }
  //  }

  //  //bolt.launch(RequestData, Handler);
  //  //this.bolt.launch(RequestData, Handler);
  //}
  //  confirmPayment() {

  //    var params = {
  //      "TransactionId": 0,
  //      "TransactionKey": "",
  //      "MerchentKey": "",
  //      "SaltKey": "",
  //      "PatientId": 4967,
  //      "AppointmentId": 23525,
  //      "UserId": 3,
  //      "FirstName": this.PaymentConfirmationObj.firstname,
  //      "Email": this.PaymentConfirmationObj.email,
  //      "Mobile": this.PaymentConfirmationObj.phone,
  //      "ProductType": this.PaymentConfirmationObj.productinfo,
  //      "Amount": this.PaymentConfirmationObj.amount,
  //      "Hash": "",
  //      "udf1": this.PaymentConfirmationObj.udf1,
  //      "udf2": this.PaymentConfirmationObj.udf2,
  //      "udf3": this.PaymentConfirmationObj.udf3,
  //      "udf4": this.PaymentConfirmationObj.udf4,
  //      "udf5": this.PaymentConfirmationObj.udf5
  //    };
  //    return this.http.post<any>(this.baseUrl + "/api/MasterPatient/createTxnHashForAppointment", params, this.options).subscribe(result => {
  //      console.log(result);
  //      if (result.Status === 'Success') {
  //        this.PaymentConfirmationObj.hash = result.HashKey;
  //        this.PaymentConfirmationObj.txnid = result.TransactionKey;
  //        this.disablePaymentButton = false;
  //        // this.boltsubmit();
  //      }

  //    }


  //}



  confirmPayment() {

    var params = {
      "TransactionId": 0,
      "TransactionKey": "",
      "MerchentKey": "",
      "SaltKey": "",
      "PatientId": 4967,
      "AppointmentId": 23525,
      "UserId": 3,
      "FirstName": this.PaymentConfirmationObj.firstname,
      "Email": this.PaymentConfirmationObj.email,
      "Mobile": this.PaymentConfirmationObj.phone,
      "ProductType": this.PaymentConfirmationObj.productinfo,
      "Amount": this.PaymentConfirmationObj.amount,
      "Hash": "",
      "udf1": this.PaymentConfirmationObj.udf1,
      "udf2": this.PaymentConfirmationObj.udf2,
      "udf3": this.PaymentConfirmationObj.udf3,
      "udf4": this.PaymentConfirmationObj.udf4,
      "udf5": this.PaymentConfirmationObj.udf5
    };
    return this.http.post<any>(this.baseUrl + "/api/MasterPatient/createTxnHashForAppointment", params, this.options).subscribe(result => {
      console.log(result);
      if (result.Status === 'Success') {
        this.PaymentConfirmationObj.hash = result.HashKey;
        this.PaymentConfirmationObj.txnid = result.TransactionKey;
        this.disablePaymentButton = false;
        // this.boltsubmit();
      }

    });

  }

  BackToPatients() {
    var url = "";
    url = "/Appointment/" + this.PaymentConfirmationObj.parentHospitalId;
    this.router.navigate([url]);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/payment.component.ts